import styled from 'styled-components';
import { Grid as SemanticGrid } from 'semantic-ui-react';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 10px 30px 10px;
`;

const Details = styled(TextLayoutComponent.Bold)`
  margin: 20px 20px 20px 20px;
  text-align: left;
`;

const Content = styled.div`
  &&& {
    font-size: 14px;
    font-weight: 500;
    margin: 10px 20px 20px 20px;
  }
  text-align: left;
`;

const Grid = styled(SemanticGrid)`
  &&& {
    padding: 0 10px 0 10px;
    text-align: left;
    margin-bottom: 10px;
  }
`;

const Row = styled(SemanticGrid.Row)`
  &&& {
    margin-bottom: -5px;
    margin-top: -20px;
    text-align: left;
  }
`;

const Column = styled(SemanticGrid.Column)`
  &&& {
    font-size: 14px;
    font-weight: ${(props) => (props.weight ? props.weight : 'normal')};
    margin: 0 10px 0 10px;
    text-align: left;
  }
`;

const ColumnName = styled(TextLayoutComponent.Bold)``;

const ColumnValue = styled(TextLayoutComponent)``;

export {
  Column,
  ColumnName,
  ColumnValue,
  Container,
  Content,
  Details,
  Grid,
  Row,
};
